//@ts-ignore
export const backendBaseURL = import.meta.env.VITE_BACKEND_BASE_URL as string;
//@ts-ignore
export const bqiBaseURL = import.meta.env.VITE_BQI_BASE_URL as string;
